import React, { useEffect } from 'react';
import HeroSection from '../components/hero/HeroSection';
import ProblemSection from '../components/problem/ProblemSection';
import SolutionSection from '../components/solution/SolutionSection';
import CTASection from '../components/cta/CTASection';
import HomeProductShowcase from '../components/product/HomeProductShowcase';
import MetricsStrip from '../components/premium/MetricsStrip';
import SectionReveal from '../components/premium/SectionReveal';
import { homeMetrics } from '../data/solutionContent';
import './Home.css';

const Home: React.FC = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="home-page">
      <section className="hero-wrapper">
        <HeroSection />
      </section>

      <SectionReveal className="home-section-reveal" delay={0.05}>
        <MetricsStrip metrics={homeMetrics} />
      </SectionReveal>

      <SectionReveal className="home-section-reveal home-product-showcase-wrapper" delay={0.08}>
        <HomeProductShowcase />
      </SectionReveal>

      <SectionReveal className="home-section-reveal problem-wrapper" delay={0.1}>
        <ProblemSection />
      </SectionReveal>

      <SectionReveal className="home-section-reveal solution-wrapper" delay={0.12}>
        <SolutionSection />
      </SectionReveal>

      <SectionReveal className="home-section-reveal cta-wrapper" delay={0.14}>
        <CTASection />
      </SectionReveal>
    </div>
  );
};

export default Home;
